export default "__VITE_ASSET__Bdcy1JgU__"